import { CircularProgress } from '@mui/material'
import styled from 'styled-components'
import { COLORS } from 'utils'

import { IconStyles } from './../types'

export const LoadingCustom = styled(CircularProgress)<IconStyles>`
  width: ${({ width }) => width || '50px'};
  height: ${({ height }) => height || 'auto'};
  margin-top: ${({ marginTop }) => marginTop || '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
  color: ${({ colorIcon }) => colorIcon || COLORS.black};
`
